import DOMPurify from 'dompurify'
import { clientePedido } from '../../apiClient/index'

export const MAX_NOTICIA_BODY_LENGTH = 4000
export const MAX_NOTICIA_EMBEDDED_IMAGE_SIZE_BYTES = 10 * 1024 * 1024

const ALLOWED_NOTICIA_TAGS = [
  'p',
  'br',
  'strong',
  'b',
  'em',
  'i',
  'u',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'blockquote',
  'a',
  'img',
  'ul',
  'ol',
  'li'
]

const ALLOWED_NOTICIA_URI_REGEXP = /^(?:https?:\/\/|\/api\/NoticiaImagen\/Get\?idNoticia=\d+&idImagen=\d+$)/i
const ALLOWED_NOTICIA_EDITOR_URI_REGEXP = /^(?:blob:|https?:\/\/|\/api\/NoticiaImagen\/Get\?idNoticia=\d+&idImagen=\d+$)/i
const NOTICIA_IMAGE_REFERENCE_REGEXP = /(?:https?:\/\/[^/\s)]+)?\/api\/NoticiaImagen\/Get\?idNoticia=\d+&idImagen=\d+/gi

const addBlankTargetToLinks = node => {
  if (node.tagName && node.tagName.toLowerCase() === 'a' && node.hasAttribute('href')) {
    node.setAttribute('target', '_blank')
    node.setAttribute('rel', 'noopener noreferrer')
  }
}

export function sanitizeNoticiaHtml(html, options = {}) {
  DOMPurify.addHook('afterSanitizeAttributes', addBlankTargetToLinks)

  try {
    return DOMPurify.sanitize(html, {
      ALLOWED_TAGS: ALLOWED_NOTICIA_TAGS,
      ALLOWED_ATTR: ['href', 'src', 'alt', 'target', 'rel'],
      ALLOWED_URI_REGEXP: options.allowLocalBlob
        ? ALLOWED_NOTICIA_EDITOR_URI_REGEXP
        : ALLOWED_NOTICIA_URI_REGEXP,
      KEEP_CONTENT: true
    })
  } finally {
    DOMPurify.removeHook('afterSanitizeAttributes')
  }
}

export function getNoticiaVisibleText(markdown) {
  return String(markdown || '')
    .replace(/<!--[\s\S]*?-->/g, ' ')
    .replace(/!\[[^\]]*\]\([^)]*\)/g, ' ')
    .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')
    .replace(/<[^>]*>/g, ' ')
    .replace(/^\s{0,3}(#{1,6}|>|[-+*]|\d+[.)])\s+/gm, ' ')
    .replace(/^\s*[-*_]{3,}\s*$/gm, ' ')
    .replace(/(\*\*|__|~~|`)/g, '')
    .replace(/\\([\\`*_[\]{}()#+.!-])/g, '$1')
    .replace(/\s+/g, ' ')
    .trim()
}

export function hasNoticiaVisibleText(markdown) {
  return getNoticiaVisibleText(markdown).length > 0
}

export function getNoticiaImageReferences(markdown) {
  return Array.from(new Set(String(markdown || '').match(NOTICIA_IMAGE_REFERENCE_REGEXP) || []))
}

export async function resolveNoticiaImageSources(markdown) {
  let resolvedMarkdown = String(markdown || '')
  const references = getNoticiaImageReferences(resolvedMarkdown)
  const objectUrls = []
  const sourceMap = {}

  for (const reference of references) {
    try {
      const response = await clientePedido.get(reference, { responseType: 'blob' })
      const objectUrl = URL.createObjectURL(response.data)
      objectUrls.push(objectUrl)
      sourceMap[reference] = objectUrl
      resolvedMarkdown = resolvedMarkdown.split(reference).join(objectUrl)
    } catch {
      // Mantiene la referencia original para que el contenido no se pierda si la descarga falla.
    }
  }

  return { markdown: resolvedMarkdown, objectUrls, sourceMap }
}